module.exports = __webpack_public_path__ + "img/unauthorized.436bd688.jpg";